export enum EMenuPlacements {
  ASIDE     = 'aside',
  BODY      = 'body',
  HEADER    = 'header',
  FEEDBACK  = 'feedback',
  FOOTER    = 'footer'
}
